import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';

const routes: Routes = [

  {
    path: '', component: HomeComponent, children: [

      {
        path: 'home',
        loadChildren: () => import('./pages/home/home.module').then(d => d.HomeModule),
      },
      {
        path: 'unidad-organica',
        loadChildren: () => import('./pages/unidad-organica/unidad-organica.module').then(d => d.UnidadOrganicaModule),
      },
      {
        path: 'adm-maestro',
        loadChildren: () => import('./pages/maestros-sistema/maestros-sistema.module').then(d => d.MaestrosSistemaModule),
      },
      {
        path: 'estructura-plan',
        loadChildren: () => import('./pages/estructura-plan/estructura-plan.module').then(d => d.EstructuraPlanModule),
      },
      {
        path: 'objetivo',
        loadChildren: () => import('./pages/objetivos/objetivos.module').then(d => d.ObjetivosModule),
      },
      {
        path: 'meta',
        loadChildren: () => import('./pages/meta/meta.module').then(d => d.MetaModule),
      },
      {
        path: 'avance',
        loadChildren: () => import('./pages/avance/avance.module').then(d => d.AvanceModule),
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./pages/dashboard/dashboard.module').then(d => d.DashboardModule),
      },
      {
        path: 'reportes',
        loadChildren: () => import('./pages/reportes/reportes.module').then(d => d.ReportesModule),
      },
      {
        path: 'centro-alertas',
        loadChildren: () => import('./pages/centro-alertas/centro-alertas.module').then(d => d.CentroAlertasModule),
      },
      {
        path: 'usuario',
        loadChildren: () => import('./pages/usuario/usuario.module').then(d => d.UsuarioModule),
      },
      {
        path: 'consulta',
        loadChildren: () => import('./pages/consulta-ciudadana/consulta-ciudadana.module').then(d => d.ConsultaCiudadanaModule),
      }
    ]
  }
  , {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then(d => d.LoginModule),
    data: { title: 'Login', breadcrumb: 'Login' }
  },
  { path: '**', pathMatch: 'full', redirectTo: '' }
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
